<template>
  <v-main>
    <v-card class="idcs-dialog-back fill-height">
      <v-card-actions>
        <v-subheader>{{$t('rec_types.UserGroupRecord')}}</v-subheader>
        <v-spacer></v-spacer>
        <v-btn icon @click="close" color="error">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form ref="form" :lazy-validation="true">
          <v-row dense>
            <v-col cols="3">
              <v-text-field
                :disabled="!clone && !newrec"
                v-model="item.id"
                :label="$t('field.name')+'*'"
                :rules="userRules"
                persistent-hint
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="bin"
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
                :rules="rules_bin"
                :label="$t('field.bin')"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="if_type"
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
                :items="if_types"
                :label="$t('admin.iface')"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="edit_type"
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
                :items="edit_types"
                :label="$t('admin.l_editor_type')"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="areports"
                :items="$store.getters['admin/reports']"
                item-text="name_id"
                item-value="id"
                multiple
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
                chips
              >
                <template v-slot:item="{item}">
                  <div>{{$store.getters['admin/msgById'](item,$i18n.locale)}}</div>
                </template>
              </v-select>
              <!--<v-text-field v-model="item.reports" :label="$t('field.reports')"></v-text-field>!-->
            </v-col>
            <v-col cols="12">
              <v-expansion-panels accordion focusable v-model="panels">
                <!-- menu !-->
                <v-expansion-panel>
                  <v-expansion-panel-header>{{$t('rules.menu')}}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-layout row wrap>
                      <v-flex v-for="m in menus" :key="m.i">
                        <RulesCheckBox v-model="item.rules" :xtag="m.t" :xval="m.v" class="ma-2"></RulesCheckBox>
                      </v-flex>
                    </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- funct !-->
                <v-expansion-panel>
                  <v-expansion-panel-header>{{$t('rules.functions')}}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-layout row wrap>
                      <v-flex lg3>
                        <RulesCheckBox v-model="item.rules" xtag="fstat" xval="w"></RulesCheckBox>
                      </v-flex>
                      <v-flex lg3>
                        <RulesCheckBox v-model="item.rules" xtag="fpin" xval="r"></RulesCheckBox>
                      </v-flex>
                      <v-flex lg3>
                        <RulesCheckBox v-model="item.rules" xtag="fpin" xval="w"></RulesCheckBox>
                      </v-flex>
                      <v-flex lg3>
                        <RulesCheckBox v-model="item.rules" xtag="fvalid" xval="w"></RulesCheckBox>
                      </v-flex>
                      <v-flex lg3>
                        <RulesCheckBox v-model="item.rules" xtag="ftrstat" xval="w"></RulesCheckBox>
                      </v-flex>
                      <v-flex lg3>
                        <RulesCheckBox v-model="item.rules" xtag="fmode" xval="s"></RulesCheckBox>
                      </v-flex>
                      <v-flex lg3>
                        <RulesCheckBox v-model="item.rules" xtag="fcopy" xval="t"></RulesCheckBox>
                      </v-flex>
                      <v-flex lg3>
                        <RulesCheckBox v-model="item.rules" xtag="fcused" xval="y"></RulesCheckBox>
                      </v-flex>
                    </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- recs !-->
                <v-expansion-panel>
                  <v-expansion-panel-header>{{$t('rules.records')}}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th></th>
                          <th>{{$t('rules.create')}}</th>
                          <th>{{$t('rules.read')}}</th>
                          <th>{{$t('rules.update')}}</th>
                          <th>{{$t('rules.delete')}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="r in recs" :key="r">
                          <i18n :path="'rec_types.'+r" class="subtitle-2"></i18n>
                          <td>
                            <RulesCheckBox
                              v-model="item.rules"
                              :xtag="r"
                              xval="c"
                              solo
                              class="ma-2"
                            ></RulesCheckBox>
                          </td>
                          <td>
                            <RulesCheckBox
                              v-model="item.rules"
                              :xtag="r"
                              solo
                              xval="r"
                              class="ma-2"
                            ></RulesCheckBox>
                          </td>
                          <td>
                            <RulesCheckBox
                              v-model="item.rules"
                              :xtag="r"
                              solo
                              xval="w"
                              class="ma-2"
                            ></RulesCheckBox>
                          </td>
                          <td>
                            <RulesCheckBox
                              v-model="item.rules"
                              :xtag="r"
                              solo
                              xval="d"
                              class="ma-2"
                            ></RulesCheckBox>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- special fields -->
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <i18n path="admin.group_cust" />
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-text-field
                      v-model="disclevels"
                      :label="$t('admin.smsdisclevels')"
                      shaped
                      outlined
                      background-color="yellow lighten-5 mt-4"
                    ></v-text-field>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
            <v-col cols="12">
              <v-textarea filled solo v-model="item.rules" :label="$t('admin.rules')"></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-alert
                v-model="showAlert"
                border="left"
                colored-border
                type="error"
                elevation="2"
                :dismissible="true"
                transition="fade-transition"
              >{{alertMessage}}</v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-show="!clone && !newrec"
          color="blue darken-1"
          text
          @click="simpleDialog=true"
        >{{$t('button.delete')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="isSms" color="blue darken-1" text @click="d_sms=true">{{$t('button.smsauth')}}</v-btn>
        <v-btn
          v-show="!clone && !newrec"
          color="blue darken-1"
          text
          @click="cloneRecord"
        >{{$t('button.clone')}}</v-btn>
        <v-btn color="blue darken-1" text @click="save(true)">{{$t('button.save')}}</v-btn>
      </v-card-actions>
    </v-card>
    <DeleteDialog v-model="simpleDialog" @click:ok="erase" />
    <v-dialog v-model="d_sms" persistent width="500">
      <v-card class="idcs-pane-back">
        <v-card-title>
          <i18n path="title.smsAuth"></i18n>
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="d_sms=false">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="smsu"
                :label="$t('field.smsuser')"
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="smsp"
                :label="$t('field.smspass')"
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="smsinfo.idx" align-content="space-between">
            <v-divider></v-divider>
            <v-col cols="4" class="subtitle-2">
              <i18n path="field.smscompany" />
            </v-col>
            <v-col cols="8" class="title text-right">{{smsinfo.companyName}}</v-col>
            <v-col cols="4" class="subtitle-2">
              <i18n path="field.smsdebit" />
            </v-col>
            <v-col cols="8" class="title text-right">{{smsinfo.debit|currency}}</v-col>
            <v-col cols="4" class="subtitle-2">
              <i18n path="field.smstarif" />
            </v-col>
            <v-col cols="8" class="title text-right">{{smsinfo.settings.tarif|currency4}}</v-col>
            <v-col cols="4" class="subtitle-2">
              <i18n path="field.smssender" />
            </v-col>
            <v-col cols="8" class="title text-right">{{smsinfo.settings.sender}}</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="blue" @click="smsAuth">
            <i18n path="button.smsauth"></i18n>
          </v-btn>
          <v-btn text color="blue" @click="smsSave" :disabled="!smsinfo.idx">
            <i18n path="button.save"></i18n>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
import app from "@/app.js";
import RulesCheckBox from "@/components/RulesCheckBox.vue";
const rec_type = "UserGroupRecord";
import DeleteDialog from "@/components/DeleteDialog.vue";

export default {
  name: "UserGroupEditor",
  components: { RulesCheckBox, DeleteDialog },
  props: {
    record: { type: Object, required: true },
    value: { type: Boolean },
    newrec: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      d_sms: false,
      smsinfo: { settings: {} },
      menus: [
        { i: "1", t: "struct", v: "r" },
        { i: "111", t: "struct", v: "l" },
        { i: "112", t: "struct", v: "s" },
        { i: "113", t: "struct", v: "m" },
        { i: "2", t: "cards", v: "r" },
        { i: "21", t: "profiles", v: "r" },
        { i: "3", t: "trans", v: "r" },
        { i: "4", t: "info", v: "r" },
        { i: "5", t: "stats", v: "r" },
        { i: "51", t: "report", v: "r" },
        { i: "6", t: "log", v: "r" },
        { i: "61", t: "actlog", v: "r" },
        { i: "7", t: "utils", v: "r" },
        { i: "8", t: "cardDets", v: "r" },
        { i: "9", t: "export", v: "r" },
        { i: "10", t: "remote", v: "r" },
        { i: "12", t: "posreport", v: "r" },
        { i: "13", t: "tickets", v: "u" },
        { i: "14", t: "tickets", v: "a" },
      ],
      recs: [
        "ErrorRecord",
        "CardRecord",
        "CardDetailRecord",
        "TransactionRecord",
        "LogRecord",
        "ReportRecord",
        "UserRecord",
        "UserGroupRecord",
        "SystemRecord",
        "SystemDetailRecord",
        "CompanyRecord",
        "SubCompanyRecord",
        "TerminalRecord",
        "FrameRecord",
        "TerminalDetailRecord",
      ],
      rules_bin: [
        (v) => !v || /\d{1,24}/.test(v) || this.$t("error.digits"),
      ],
      panels: null,
      if_types: [],
      edit_types: [],
      clone: this.newrec,
      simpleDialog: false,
      showAlert: false,
      alertMessage: "",
      userRules: [(v) => !!v || this.$t("error.required")],
      item: { ...this.record },
      smsp: "",
      smsu: "",
    };
  },
  watch: {
    record: {
      handler(nw) {
        this.clone = this.newrec;
        this.item = { ...nw };
        this.panels = null;
      },
      deep: true,
    },
  },
  created() {
    this.if_types = [];
    this.$t("admin.interface_type").forEach((e, i) => {
      this.if_types.push({
        text: e,
        value: i.toString(),
      });
    });
    this.edit_types = [];
    this.$t("admin.editor_type").forEach((e, i) => {
      this.edit_types.push({
        text: e,
        value: i.toString(),
      });
    });
  },
  computed: {
    disclevels: {
      cache: false,
      get() {
        return this.getRule("smsdisclevels", "");
      },
      set(v) {
        this.setRule("smsdisclevels", v);
      },
    },
    areports: {
      get() {
        return this.item.reports ? this.item.reports.split(",") : [];
      },
      set(v) {
        return (this.item.reports = v.join(","));
      },
    },
    bin: {
      cache: false,
      get() {
        let ret = new RegExp("<bin>(.+)</bin>", "gi").exec(this.item.rules);
        return ret ? ret[1] : "";
      },
      set(v) {
        const t = new RegExp("<bin>(.+)</bin>", "gi");
        let res = t.exec(this.item.rules);
        if (res) {
          this.item.rules = this.item.rules.replace(
            res[0],
            v ? "<bin>" + v + "</bin>" : ""
          );
        } else {
          this.item.rules = this.item.rules += "<bin>" + v + "</bin>";
        }
      },
    },
    if_type: {
      cache: false,
      get() {
        return this.getRule("interface", "1");
      },
      set(v) {
        this.setRule("interface", v);
      },
    },
    edit_type: {
      cache: false,
      get() {
        return this.getRule("editor", "0");
      },
      set(v) {
        this.setRule("editor", v);
      },
    },
    isSms() {
      return this.getRule("profiles") == "r";
    },
  },
  methods: {
    smsSave() {
      this.setRule("smsu", this.smsu);
      this.save();
      this.d_sms = false;
    },
    smsAuth() {
      app
        .smsAuth({
          username: this.smsu,
          password_: this.$CryptoJS.enc.Base64.stringify(
            this.$CryptoJS.SHA256(this.smsp)
          ),
        })
        .then((response) => {
          this.smsinfo = response.data;
        });
    },
    getRule(r, def) {
      let ret = new RegExp("<" + r + ">(.+)</" + r + ">", "gi").exec(
        this.item.rules
      );
      return ret ? ret[1] : def;
    },
    setRule(r, v) {
      const t = new RegExp("<" + r + ">(.+)</" + r + ">", "gi");
      let newval = "<" + r + ">" + v + "</" + r + ">";
      if (t.exec(this.item.rules)) {
        this.item.rules = this.item.rules.replace(t, v ? newval : "");
      } else {
        if (v) this.item.rules += newval;
      }
    },
    cloneRecord() {
      this.clone = true;
      this.item.id = "";
    },
    erase() {
      app
        .erase(this.item.id, rec_type)
        .then(() => {
          this.item.rec_type = rec_type;
          this.$store.commit("admin/remove_group", this.item);
          this.$emit("delete", this.item);
          this.close();
        })
        .catch((error) => {
          this.showAlertMessage(error);
        });
    },
    close() {
      this.$emit("input", false);
    },
    save() {
      if (!this.$refs.form.validate()) return;
      let params = {
        id: this.item.id,
        reports: this.item.reports,
        rules: this.item.rules,
      };
      app
        .update(this.clone ? "newrec" : this.item.id, rec_type, params)
        .then(() => {
          this.item.rec_type = rec_type;
          if (this.clone) {
            this.$store.commit("admin/insert_group", this.item);
            this.$emit("insert", this.item);
          } else {
            this.$store.commit("admin/update_group", this.item);
            this.$emit("update", this.item);
          }
          this.close();
        })
        .catch((error) => {
          this.showAlertMessage(error);
        });
    },
    showAlertMessage(m) {
      if (m.errorMsg) {
        this.alertMessage = this.$t("error." + m.errorMsg);
      } else {
        this.alertMessage = JSON.stringify(m);
      }
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 4000);
    },
  },
};
</script>

<style scoped>
</style>